var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinanace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6095 6.94281C12 6.55228 12 5.92375 12 4.66667C12 3.40959 12 2.78105 11.6095 2.39052M11.6095 6.94281C11.219 7.33333 10.5904 7.33333 9.33333 7.33333H6.66667C5.40959 7.33333 4.78105 7.33333 4.39052 6.94281M11.6095 6.94281C11.6095 6.94281 11.6095 6.94281 11.6095 6.94281ZM11.6095 2.39052C11.219 2 10.5904 2 9.33333 2L6.66667 2C5.40959 2 4.78105 2 4.39052 2.39052M11.6095 2.39052C11.6095 2.39052 11.6095 2.39052 11.6095 2.39052ZM4.39052 2.39052C4 2.78105 4 3.40959 4 4.66667C4 5.92375 4 6.55228 4.39052 6.94281M4.39052 2.39052C4.39052 2.39052 4.39052 2.39052 4.39052 2.39052ZM4.39052 6.94281C4.39052 6.94281 4.39052 6.94281 4.39052 6.94281Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66659 4.66667C8.66659 5.03486 8.36811 5.33333 7.99992 5.33333C7.63173 5.33333 7.33325 5.03486 7.33325 4.66667C7.33325 4.29848 7.63173 4 7.99992 4C8.36811 4 8.66659 4.29848 8.66659 4.66667Z",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4C10.8954 4 10 3.10457 10 2",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.33325C10.8954 5.33325 10 6.22868 10 7.33325",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4C5.10457 4 6 3.10457 6 2",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.33325C5.10457 5.33325 6 6.22868 6 7.33325",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 13.5922H4.83987C5.51378 13.5922 6.19494 13.6624 6.8508 13.7975C8.01096 14.0365 9.23248 14.0655 10.4046 13.8758C10.9825 13.7822 11.5506 13.6392 12.0649 13.3909C12.5292 13.1668 13.0979 12.851 13.4799 12.4972C13.8613 12.1439 14.2586 11.5657 14.5405 11.1137C14.7823 10.7262 14.6654 10.2507 14.2829 9.96195C13.8581 9.64118 13.2277 9.64124 12.803 9.96209L11.5982 10.8722C11.1313 11.2249 10.6212 11.5496 10.0136 11.6465C9.94059 11.6582 9.86403 11.6688 9.78416 11.678M9.78416 11.678C9.76011 11.6808 9.73577 11.6835 9.71113 11.686M9.78416 11.678C9.88135 11.6572 9.97787 11.5973 10.0684 11.5183C10.4972 11.144 10.5243 10.5133 10.1523 10.0953C10.066 9.99837 9.96495 9.91751 9.85263 9.85052C7.98774 8.73822 5.0862 9.58539 3.33325 10.8285M9.78416 11.678C9.75983 11.6833 9.73546 11.686 9.71113 11.686M9.71113 11.686C9.36222 11.7218 8.95403 11.7311 8.5011 11.6883",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.33325,
    y: 9.33325,
    width: 2,
    height: 5.33333,
    rx: 1,
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanace);
export default __webpack_public_path__ + "static/media/finanace.063c0a595651f1d059d90695902b0739.svg";
export { ForwardRef as ReactComponent };